/**
 * Auto-generated TypeScript types from OpenAPI specification
 * 
 * Title: App Template API
 * Version: 1.0.0
 * 
 * DO NOT EDIT THIS FILE DIRECTLY
 */

  import type {
    ListCategoriesResponse
  } from '@app/shared/types';
  import type { AxiosResponse } from 'axios';
  import { apiClient } from './apiClient';
  import {
  useQuery, type UseQueryOptions
  } from '@tanstack/react-query';


/**
 * List all product categories
 * 
 * @endpoint GET /categories
 */
export const listCategories = (): Promise<AxiosResponse<ListCategoriesResponse>> => {
  return apiClient.get<ListCategoriesResponse>('/categories');
};



/**
 * List all product categories
 * 
 * @endpoint GET /categories
 */
export const useListCategories = (options?: UseQueryOptions<ListCategoriesResponse>) => {
  return useQuery<ListCategoriesResponse>({
    queryKey: ['listCategories'],
    queryFn: async () => {
      const { data } = await listCategories();
      return data;
    },
    ...options,
  });
};

